import { usePage, useWebsiteSettings } from 'publisher/store'

import pageSelectors from 'publisher/store/page/pageSelectors'
import { getWebsiteTheme } from 'src/publisher/store/website-settings/website-settings-selector'

export const useThemeColor = () => {
  const pageGlobalLinkColor = usePage(pageSelectors.getGlobalLinkColor)

  const PageGlobalTextColor = usePage(pageSelectors.getGlobalTextColor)
  const PageGlobalHeadingColor = usePage(pageSelectors.getGlobalHeadingColor)
  const {
    background,
    headerAndFooter,
    text,
    buttons,
    links,
    formFields,
    miscellaneous,
  } = useWebsiteSettings(getWebsiteTheme) || {}
  return {
    background,
    headerAndFooter,
    text: {
      ...text,
      paragraphTextColor: PageGlobalTextColor || text?.paragraphTextColor,
      headingTextColor: PageGlobalHeadingColor || text?.headingTextColor,
    },
    buttons,
    links: {
      ...links,
      linkTextColor: pageGlobalLinkColor || links?.linkTextColor,
    },
    formFields,
    miscellaneous,
  }
}
